import { TDPropsWithoutRef } from "react-html-props";
import styled from "styled-components";
import collapsable, { CollapsableProps } from "./collapsable";

interface TDProps extends TDPropsWithoutRef, CollapsableProps {}

const Td = styled.td<TDProps>`
  ${collapsable};

  // Extra specificity to deal with some default styles sneaking in from the
  // global bootstrap table styles.
  &&,
  &&:hover {
    border-radius: 0;
  }

  padding: 1rem;
  /* white-space: nowrap; */
  background-color: inherit;

  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
`;

export default Td;
